// eslint-disable-next-line import/prefer-default-export
export const projectSchedule = {
  "% Complete": "% Completo",
  "$ Project Cost": "Custo do Projeto",
  "Add New": "Adicionar Novo",
  "All Colors": "Todas as Cores",
  "All Dates": "Todas as Datas",
  "Are you sure you want to delete the activity": "Tem certeza de que deseja excluir a atividade?",
  "Are you sure you want to delete the group": "Tem certeza de que deseja excluir o grupo?",
  "Are you sure you want to delete the milestone": "Tem certeza de que deseja excluir o marco?",
  "Are you sure?": "Você tem certeza?",
  "Basic Blue": "Azul Básico",
  "Beneficial Brown": "Marrom Benéfico",
  "Blissful Blue": "Feliz Azul",
  "change(s)": "mudar(s)",
  "Choose color": "Escolha a cor",
  "Click here": "Clique aqui",
  "Copy Link": "Copiar link",
  "Create Activity": "Criar Atividade",
  "Create Group": "Criar Grupo",
  "Create Milestone": "Criar Marco",
  "Create Roadblock": "Criar Obstáculo",
  "Daily Reports": "Relatórios Diários",
  "Date Format:": "Formato da Data:",
  "Day-Month-Year": "Dia-Mês-Ano",
  "Default Color": "Cor Padrão",
  "Delete Activity": "Excluir Atividade",
  "Delete Group": "Excluir Grupo",
  "Delete Milestone": "Excluir Marco",
  "Dependent On": "Dependente De",
  "Depends On": "Depende De",
  "Due Date": "Data de Vencimento",
  "Due Today": "Vencimento hoje",
  "End Date": "Data de Fim",
  "Expand All Groups": "Expandir Todos os Grupos",
  "Export to Excel": "Exportar para Excel",
  "Gainful Green": "Verde Ganho",
  "Get It Done Grey": "Faça isso cinza",
  "Golfer's Green": "Verde do Golfista",
  "Great Green": "Grande Verde",
  "Hide": "Esconder",
  "Hide Completed": "Ocultar Concluídos",
  "Import from Excel": "Importar do Excel",
  "Import or export": "Importar ou exportar",
  "In Progress": "Em andamento",
  "Invite people": "Convidar pessoas",
  "made": "feita",
  "Magnifying Magenta": "Ampliando Magenta",
  "Month-Day-Year": "Mês-Dia-Ano",
  "No other activity depends on this activity.": "Nenhuma outra atividade depende desta.",
  "No records to display": "Não há registros para exibir",
  "Operational Orange": "Laranja Operacional",
  "Outstanding Orange": "Laranja excepcional",
  "PDF Settings": "Configurações de PDF",
  "Pretty Pink": "Muito rosa",
  "Productive Purple": "Roxo Produtivo",
  "Project Cost": "Custo do Projeto",
  "Project Schedule": "Agenda do Projeto",
  "Prolific Purple": "Roxo prolífico",
  "Real Duration": "Duração Real",
  "Real Finish Date": "Data de término real",
  "Real Finish": "Acabamento Real",
  "Real Start Date": "Data de Início Real",
  "Real Start": "Início Real",
  "Real Times": "Tempos Reais",
  "Recommended: All Dates": "Recomendado: todas as datas",
  "Recommended: Due Today": "Recomendado: vencimento hoje",
  "Recommended: In Progress": "Recomendado: em andamento",
  "Recommended: Overdue": "Recomendado: Vencido",
  "Rosy Red": "Vermelho rosado",
  "Scheduled Duration": "Duração Programada",
  "Scheduled End Date": "Data de Término Programada",
  "Scheduled End": "Fim Programado",
  "Scheduled Start Date": "Data de Início Programada",
  "Scheduled Start": "Início Programado",
  "Scheduled Times": "Tempos Programados",
  "Select a type": "Selecione um tipo",
  "Select Assignees": "Selecionar Atribuídos",
  "Select Colors": "Selecionar Cores",
  "Show Completed": "Mostrar Concluídos",
  "Size": "Tamanho",
  "Start Date": "Data de Início",
  "Starting: Within 1 Week": "Início: dentro de 1 semana",
  "Starting: Within 2 Weeks": "Início: dentro de 2 semanas",
  "Starting: Within 4 Weeks": "Início: dentro de 4 semanas",
  "Submitting...": "Submetendo...",
  "to download the file and review the errors in the last column." : "para baixar o arquivo e revisar os erros na última coluna.",
  "to download the sample file. Your uploaded file must be based on this template and adhere to the outlined requirements.": "para baixar o arquivo de amostra. O arquivo enviado deve ser baseado neste modelo e atender aos requisitos descritos.",
  "Task Due": "Tarefa Vencida",
  "Task Due: Within 1 Week": "Vencimento da tarefa: dentro de 1 semana",
  "Task Due: Within 2 Weeks": "Vencimento da tarefa: dentro de 2 semanas",
  "Task Due: Within 4 Weeks": "Tarefa vencida: dentro de 4 semanas",
  "There are no comments in this activity.": "Não há comentários nesta atividade.",
  "There are no comments in this group.": "Não há comentários neste grupo.",
  "There are no dependents/depedencies of this activity.": "Não há dependentes/dependências desta atividade.",
  "There are no histories in this group.": "Não há históricos neste grupo.",
  "There are no items in this module.": "Não há itens neste módulo.",
  "There are no more daily reports available.": "Não há mais relatórios diários disponíveis.",
  "There are no more documents available.": "Não há mais documentos disponíveis.",
  "There are no more drawings available.": "Não há mais desenhos disponíveis.",
  "There are no more inspections available.": "Não há mais inspeções disponíveis.",
  "There are no more meetings available.": "Não há mais reuniões disponíveis.",
  "There are no more RFIs available.": "Não há mais RFIs disponíveis.",
  "There are no more tasks available.": "Não há mais tarefas disponíveis.",
  "There is history in this activity.": "Há histórico nesta atividade.",
  "There is history in this group.": "Há histórico neste grupo.",
  "This activity does noes depend on any other activity.": "Esta atividade não depende de nenhuma outra.",
  "This feature is under construction.": "Esta funcionalidade está em construção.",
  "Today": "Hoje",
  "Update Roadblock": "Atualizar Bloqueio",
  "Within 1 Week": "Dentro de 1 semana",
  "Within 2 Weeks": "Dentro de 2 semanas",
  "Within 4 Weeks": "Dentro de 4 semanas",
  "Year-Month-Day": "Ano-Mês-Dia",
  "You do not have the appropriate permission to perform this action.": "Você não tem a permissão apropriada para executar esta ação.",
  "Your file was not imported due to errors." : "Seu arquivo não foi importado devido a erros.",
  "You have marked this milestone as completed.": "Você marcou este marco como concluído.",
  "You have marked this milestone as not completed.": "Você marcou este marco como não concluído.",
  "You have not invited anyone yet.": "Você ainda não convidou ninguém.",
  "View": "Visualizar",
  Activities: "Atividades",
  Activity: "Atividade",
  Assigned: "Atribuído",
  Assignees: "Atribuídos",
  Blueberry: "Mirtilo",
  Budget: "Orçamento",
  Cancel: "Cancelar",
  Chart: "Gráfico",
  Close: "Fechar",
  CLOSE: "FECHAR",
  Colors: "Cores",
  Comments: "Comentários",
  Cost: "Custo",
  Create: "Criar",
  Day: "Dia",
  Dependencies: "Dependências",
  Description: "Descrição",
  Difference: "Diferença",
  Documents: "Documentos",
  Drawings: "Desenhos",
  Duration: "Duração",
  Email: "E-mail",
  Error: "Erro",
  Everyone: "Todos",
  Expenses: "Despesas",
  Files: "Arquivo",
  Files: "Arquivos",
  Grid: "Grade",
  History: "Histórico",
  Inspections: "Inspeções",
  Invite: "Convidar",
  Meetings: "Reuniões",
  Milestone: "Marco",
  Mustard: "Mostarda",
  Name: "Nome",
  No: "Não",
  OPEN: "ABRIR",
  Overdue: "Atrasado",
  Permissions: "Permissões",
  Please: "Por favor",
  Predecessor: "Predecessor",
  Progress: "Progresso",
  Recommended: "Recomendado",
  RESCHEDULE: "REAGENDAR",
  RFIs: "RFIs",
  Roadblocks: "Obstáculos",
  Select: "Selecionar",
  Send: "Submeter",
  Share: "Compartilhar",
  Starting: "Começando",
  Status: "Status",
  Submit: "Enviar",
  Success: "Sucesso",
  Successor: "Sucessor",
  Tasks: "Tarefas",
  Title: "Título",
  to: "para",
  Total: "Total",
  Update: "Atualizar",
  Week: "Semana",
  Yes: "Sim",
  "DOWNLOAD PDF": "BAIXAR PDF",
  "POPULATE SAMPLE DATA": "PREENCHER DADOS DE AMOSTRA",
  "Additional Columns": "Colunas Adicionais",
  ACTIVITY_CREATED: "A atividade foi criada",
  ACTIVITY_UPDATED_ASSIGNEES_CREATED: 'Atribuído "{{ name }}" foi adicionado',
  ACTIVITY_UPDATED_ASSIGNEES_REMOVED: 'Atribuído "{{ name }}" foi removido',
  ACTIVITY_UPDATED_COLOR: 'A cor foi alterada de "{{ old }}" para "{{ new }}"',
  ACTIVITY_UPDATED_DESCRIPTION: 'A descrição foi alterada de "{{ old }}" para "{{ new }}"',
  ACTIVITY_UPDATED_ID_ACTIVITY_UPDATED: 'O predecessor foi alterado de "{{ old }}" para "{{ new }}"',
  ACTIVITY_UPDATED_PROGRESS: 'O progresso foi alterado de "{{ old }}" para "{{ new }}"',
  ACTIVITY_UPDATED_PROJECT_COST_EXPENSES_CREATED: 'Linha de despesa "{{ title }}" foi adicionada',
  ACTIVITY_UPDATED_PROJECT_COST_EXPENSES_REMOVED: 'Linha de despesa "{{ title }}" foi removida',
  ACTIVITY_UPDATED_PROJECT_COST_EXPENSES_UPDATED_AMOUNT:
    'O valor foi alterado de "{{ old }}" para "{{ new }}" na linha de despesa "{{ number }}"',
  ACTIVITY_UPDATED_PROJECT_COST_EXPENSES_UPDATED_FILE:
    'O arquivo foi alterado de "{{ old }}" para "{{ new }}" na linha de despesa "{{ number }}"',
  ACTIVITY_UPDATED_PROJECT_COST_EXPENSES_UPDATED_TITLE:
    'O título foi alterado de "{{ old }}" para "{{ new }}" na linha de despesa "{{ number }}"',
  ACTIVITY_UPDATED_PROJECT_COST_BUDGET: 'O orçamento foi alterado de "{{ old }}" para "{{ new }}"',
  ACTIVITY_UPDATED_REAL_TIMES_END: 'O horário de término real foi alterado de "{{ old }}" para "{{ new }}"',
  ACTIVITY_UPDATED_REAL_TIMES_START: 'O horário de início real foi alterado de "{{ old }}" para "{{ new }}"',
  ACTIVITY_UPDATED_SCHEDULED_TIMES_END: 'O horário de término programado foi alterado de "{{ old }}" para "{{ new }}"',
  ACTIVITY_UPDATED_SCHEDULED_TIMES_START: 'O horário de início programado foi alterado de "{{ old }}" para "{{ new }}"',
  ACTIVITY_UPDATED_TITLE: 'O título foi alterado de "{{ old }}" para "{{ new }}"',
  DAILY_REPORT_CREATED: 'Relatório diário "{{ title }}" foi adicionado',
  DAILY_REPORT_REMOVED: 'Relatório diário "{{ title }}" foi removido',
  DOCUMENT_CREATED: 'Documento "{{ name }}" foi adicionado',
  DOCUMENT_REMOVED: 'Documento "{{ name }}" foi removido',
  DRAWING_CREATED: 'Desenho "{{ name }}" foi adicionado',
  DRAWING_REMOVED: 'Desenho "{{ name }}" foi removido',
  INSPECTION_CREATED: 'Inspeção "{{ title }}" foi adicionada',
  INSPECTION_REMOVED: 'Inspeção "{{ title }}" foi removida',
  MEETING_CREATED: 'Reunião "{{ title }}" foi adicionada',
  MEETING_REMOVED: 'Reunião "{{ title }}" foi removida',
  RFI_CREATED: 'RFI "{{ title }}" foi adicionado',
  RFI_REMOVED: 'RFI "{{ title }}" foi removido',
  ROADBLOCK_CREATED: 'Obstáculo "{{ description }}" foi criado',
  ROADBLOCK_UPDATED_ASSIGNEES_CREATED: 'Atribuído "{{ name }}" foi adicionado ao obstáculo "{{ description }}"',
  ROADBLOCK_UPDATED_ASSIGNEES_REMOVED: 'Atribuído "{{ name }}" foi removido do obstáculo "{{ description }}"',
  ROADBLOCK_UPDATED_DATE: 'A data foi alterada de "{{ old }}" para "{{ new }}" no obstáculo "{{ description }}"',
  ROADBLOCK_UPDATED_DESCRIPTION:
    'A descrição foi alterada de "{{ old }}" para "{{ new }}" no obstáculo "{{ description }}"',
  ROADBLOCK_UPDATED_STATUS: 'O status foi alterado de "{{ old }}" para "{{ new }}" no obstáculo "{{ description }}"',
  ROADBLOCK_UPDATED_TYPE: 'O tipo foi alterado de "{{ old }}" para "{{ new }}" no obstáculo "{{ description }}"',
  TASK_CREATED: 'Tarefa "{{ title }}" foi adicionada',
  TASK_REMOVED: 'Tarefa "{{ title }}" foi removida',
};
